<template lang="pug">
  .columns.my-2.py-2.align-center
    .column.col-2.column-cover
      img.img-cover.img-responsive(:src="item.cover || require('@/assets/video-thumbnail-default.png')")
    .column
      .text-bold {{ item.title }}
      .columns
        .column
          .text-small(v-if="time.secondsWatched") Assistido: #[b ≅ {{ time.secondsWatched | secondsToMinutes }} {{ time.secondsWatched > 60 ? 'minutos' : 'minuto' }}]
        .column.col-auto
          .text-small
            span.tooltip.tooltip-left(data-tooltip="Total de visualizações")
              i.fas.fa-eye
            | &nbsp;{{ time.views }}
</template>

<script>
export default {
  props: {
    item: { type: Object, required: true },
    watchedTime: { type: Array, required: true },
  },
  computed: {
    time() {
      const time = this.watchedTime.find(
        ({ productItemId }) => productItemId === this.item.id,
      )

      return time
    },
  },
}
</script>

<style lang="stylus" scoped>
.columns
  border-bottom 1px solid #eee
  &:last-child
    border-bottom none
  .column-cover
    min-width 70px
.img-cover
  border-radius 5px
</style>
